// app/FastResearchEntry.js
import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./i18n"; // Initialize i18next for translations
import { useTranslation } from "react-i18next";
import UltraFastResearch from "./components/UltraFastResearch";
import ProgressTracker from "./components/ultrafastresearcher/ProgressTracker";
import FastResearchResults from "./components/ultrafastresearcher/FastResearchResults";
import Axios from "axios";

// Set Axios base URL based on environment
const backendUrl =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_BACKEND_URL_PROD
    : process.env.REACT_APP_BACKEND_URL_DEV;

Axios.defaults.baseURL = backendUrl;

function UltraFastResearchMain() {
  const { ready } = useTranslation('fastresearch');

  useEffect(() => {
    if (!ready) return;
    const splash = document.getElementById('splash');
    if (splash) {
      splash.style.display = 'none';
    }
  }, [ready]);

  if (!ready) return null; // Keep splash visible until i18n detects language

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<UltraFastResearch />} />
        <Route path="/ultrafastresearch" element={<UltraFastResearch />} />
        <Route path="/ultrafastresearch.html" element={<UltraFastResearch />} />
        <Route path="/ultrafastresearch/:id/progress" element={<ProgressTracker />} />
        <Route path="/ultrafastresearch/:id/results" element={<FastResearchResults />} />
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.querySelector("#app"));
root.render(<UltraFastResearchMain />);
